var render = function render(_c,_vm){return _c('svg',{staticClass:"sort-control",class:[_vm.data.class, _vm.data.staticClass],attrs:{"height":"18","viewBox":"0 0 5 10"}},[_c('path',{class:{active: _vm.props.sort === 'asc'},attrs:{"d":"M 1,6 L 5,6 L 3,8 Z"}}),_c('path',{class:{active: _vm.props.sort === 'desc'},attrs:{"d":"M 1,4 L 5,4 L 3,2 Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }